import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import ProcedureEditor from './ProcedureEditor';

const ProcedureEditorBridge = react2angular(ProcedureEditor, [
  'procedure',
  'editorMode'
]);

export default ProcedureEditorBridge;
